<template>
  <div class="relative" v-if="typeList.length">
    <Checkbox class="checkall textstyle" :style="{top:checkAllBtnTop+'px',right:checkAllBtnRight+'px'}" v-model="checkallstate" @on-change="checkall">{{checkallstate?$t('option.w67'):$t('option.w1')}}</Checkbox>
    <div v-for="v in typeList" :key="v.Id" class="item">
      <div class="suffix"><b>{{v.Name}}</b> <Checkbox v-model="v.checked" @on-change="p_check(v)" class="textstyle">{{v.checked?$t('option.w67'):$t('option.w1')}}</Checkbox></div>
      <div>
        <Checkbox class="tabstyle" :style="{width:'84px'}" v-for="item in v.Item" :key="item.Id" v-model="item.checked" @on-change="c_change(v)">{{item.Name}}</Checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import {getOnce} from '@/libs/axios'
export default {
  props:{
    checkAllBtnTop:{
      default:-30,
      type:Number
    },
    checkAllBtnRight:{
      default:0,
      type:Number
    },
    initValue:{
      default:null
    }
  },
  data() {
    return {
      typeList: [],
      checkallstate:false
    };
  },
  methods: {
    async getList() {
      let res = await getOnce("/Member/RZJLoan/DomainTypeConfigList");
      if (res.err) return;
      this.typeList = res;
      if(this.initValue) this.setValue(this.initValue)
      else{
        this.$watch('initValue',v=>this.setValue(v))
      }
    },
    // 子选项
    c_change(v){
      let count=v.Item.filter(x=>x.checked).length
      this.$set(v,'checked',count>=v.Item.length)
      this.getcheckallstate()
    },
    // 父选项
    p_check(v){
      v.Item.forEach(vv=>{
        this.$set(vv,'checked',v.checked)
      })
      this.getcheckallstate()
    },
    getcheckallstate(){
      let count=this.typeList.filter(x=>x.checked).length
      this.checkallstate=(count>=this.typeList.length)
      this.emit()
    },
    // 全选
    checkall(){
      this.typeList.forEach(v=>{
        this.$set(v,'checked',this.checkallstate)
        v.Item.forEach(vv=>{
          this.$set(vv,'checked',this.checkallstate)
        })
      })
      this.emit()
    },
    clear(){
      this.checkallstate=false
      this.checkall()
    },
    // 回发
    emit(){
      let arr=[]
      this.typeList.forEach(v=>{
        v.Item.forEach(vv=>{
          if(vv.checked){
            arr.push({s:v.Id,t:vv.Id})
          }
        })
      })
      arr=(arr.length?JSON.stringify(arr):'')
      this.$emit('change',arr)
    },
    setValue(p){
      if(!p) return;
      if(this.watcher) this.watcher()
      this.typeList.forEach(v=>{
        let pp=p[v.Id.toString()]
        if(!pp) return;
        v.Item.forEach(vv=>{
          if(pp.indexOf(vv.Id)>-1){
            vv.checked=true
            this.c_change(v)
          }
        })
      })      
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.checkall{
  position: absolute;
}
.item {
  margin-bottom:15px; 
  // background: #f2f4f9;
  // padding:10px;
  // border-radius: 8px;
  .suffix {
    margin-bottom: 5px;
    b{
      font-size: 14px;
      margin-right: 15px;
    }
  }
}
</style>
